import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AdminAuthContext = createContext();

const API = '/api';

export const useAdminAuth = () => {
  const context = useContext(AdminAuthContext);
  if (!context) {
    throw new Error('useAdminAuth must be used within AdminAuthProvider');
  }
  return context;
};

export const AdminAuthProvider = ({ children }) => {
  const [adminToken, setAdminToken] = useState(localStorage.getItem('adminToken'));
  const [isAdminAuthenticated, setIsAdminAuthenticated] = useState(!!localStorage.getItem('adminToken'));
  const [loading, setLoading] = useState(false);

  const adminLogin = async (username, password) => {
    try {
      setLoading(true);
      const response = await axios.post(`${API}/admin/login`, { username, password });
      const { token } = response.data;
      localStorage.setItem('adminToken', token);
      setAdminToken(token);
      setIsAdminAuthenticated(true);
      return { success: true };
    } catch (error) {
      console.error('Admin login error:', error);
      return { success: false, error: error.response?.data?.detail || 'Login failed' };
    } finally {
      setLoading(false);
    }
  };

  const adminLogout = () => {
    localStorage.removeItem('adminToken');
    setAdminToken(null);
    setIsAdminAuthenticated(false);
  };

  const value = {
    adminToken,
    isAdminAuthenticated,
    adminLogin,
    adminLogout,
    loading
  };

  return <AdminAuthContext.Provider value={value}>{children}</AdminAuthContext.Provider>;
};
